import React from "react";
import "./styles.css";

// Кнопка. Модификаторы: btn-success (основное действие), btn-danger (опасное), btn_wf.
export default function Button({ className = '', type = 'button', children, ...other }) {
    return <button {...other} type={type} className={`btn ${className}`}>{children}</button>;
}
